import type { Messages } from '../en'

export const journey: Messages['journey'] = {
  runStarted: 'Execução iniciada',
  reviewedRequest: 'Analisou seu pedido',
  gatheredAdditionalMaterials: 'Reuniu materiais adicionais',
  attachmentsChip: (n) => (n === 1 ? '1 anexo' : `${n} anexos`),
  referenceDocumentsChip: (n) => (n === 1 ? '1 documento de referência' : `${n} documentos de referência`),
  working: 'Trabalhando',
  workAnalysis: 'análise',
  workDrafting: 'redação',
  workHandsOnTasks: (n) => (n === 1 ? '1 tarefa prática' : `${n} tarefas práticas`),
  workOutsideLookups: (n) => (n === 1 ? '1 consulta externa' : `${n} consultas externas`),
  workNotesUpdated: 'anotações atualizadas',
  specialistTeamAtWork: 'Equipe de especialistas trabalhando',
  specialistTeamWorking: (n) =>
    n === 1
      ? 'Equipe de especialistas trabalhando — 1 especialista'
      : `Equipe de especialistas trabalhando — ${n} especialistas`,
  specialistTeamDone: (n) =>
    n === 1 ? 'Equipe de especialistas — 1 especialista' : `Equipe de especialistas — ${n} especialistas`,
  specialistProgress: (done, total, failed) =>
    `${done} de ${total} ${done === 1 ? 'concluído' : 'concluídos'}${
      failed > 0 ? ` · ${failed === 1 ? '1 teve problemas' : `${failed} tiveram problemas`}` : ''
    }`,
  moreChip: (n) => `+${n}`,
  askedYouAQuestion: 'Fez uma pergunta para você',
  askedYouAQuestionRound: (round) => `Fez uma pergunta para você (rodada ${round})`,
  noReplyInTime: 'Sem resposta a tempo — continuou com premissas documentadas',
  cancelledByYou: 'Cancelada por você',
  youReplied: 'Você respondeu',
  hitASnag: 'Encontrou um obstáculo — recuperação automática',
  hitASnagTimes: (n) => `Encontrou um obstáculo — recuperação automática (×${n})`,
  packagedDeliverable: 'Empacotou a entrega',
  filesChip: (n) => (n === 1 ? '1 arquivo' : `${n} arquivos`),
  delivered: 'Entregue',
  deliveredWithNotes: 'Entregue — com observações',
  runFailedTitle: 'A execução encontrou um problema e parou',
  runFailedDetail: 'Nossa equipe tem acesso aos detalhes — você também pode tentar iniciar uma nova execução.'
}
